<div class="item-funcionalidade animated fadeIn {{classCustom}}">
    <div class="icone">
        <mat-icon>{{data.icone}}</mat-icon>
    </div>   
    <h3>{{data.titulo}}</h3>    
    <article [innerHtml]="data.descricao | safeHtml"></article>
</div>  